export const ISO_DATE = "YYYY-MM-DD";
